// src/hooks/useResponseHistory.js

import { useState } from 'react';
import { SUMMARIZE_CONFIG } from '../common/Constants';

function useResponseHistory() {
  const [responseHistory, setResponseHistory] = useState([]);
  
  const addNewResponse = (characterConfig, userInput, isFakeResponse) => {
    // Use the functional form of setResponseHistory to access the latest state
    setResponseHistory((prevHistory) => {
      const combinedResponses = prevHistory
      .filter((response) => response.isChecked)
      .map(
        (response) =>
          `##\n\nAdvice from ${response.characterConfig.name}: "${response.response}"\n\n##`
      )
      .join('\n\n');

    const newHistoryItem = {
      id: Date.now(),
      characterConfig,
      userInput,
      previousResponses: combinedResponses, // Use calculated responses
      isFakeResponse,
      isSummarizer: false,
      isResponseOpen: true,
      isChecked: false,
    };

      return [newHistoryItem, ...prevHistory];
    });
  };

  const summarizeResponses = (userInput, isFakeResponse) => {
    const summarizerConfig = SUMMARIZE_CONFIG;
    setResponseHistory((prevHistory) => {
    // Calculate combined responses before summarizing
      const combinedResponses = prevHistory
      .filter((response) => response.isChecked)
      .map(
        (response) =>
          `Advice from ${response.characterConfig.name} ${response.id}: "${response.response}"`
      )
      .join('\n\n');

    const newHistoryItem = {
      id: Date.now(),
      characterConfig: summarizerConfig,
      userInput,
      previousResponses: combinedResponses, // Use calculated responses
      previousCharacter: 'some people',
      isFakeResponse,
      isSummarizer: true,
      isResponseOpen: true,
    };

      return [newHistoryItem, ...prevHistory.map((entry) => ({ ...entry, isResponseOpen: false }))];
    });
  };

  return {
    responseHistory,
    addNewResponse,
    summarizeResponses,
    setResponseHistory,
  };
}

export default useResponseHistory;
